import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface LoadingDialogData {
  title?: string;
  message?: string;
  scrollToTopOnClose?: boolean;
}
export const defaultLoadingDialogData: LoadingDialogData = {
  message: 'Please wait while we process your request',
  scrollToTopOnClose: true
};

@Component({
  selector: 'iq-loading',
  templateUrl: './loading.dialog.html',
  styleUrls: ['./loading.dialog.scss']
})
export class LoadingDialog implements OnInit {
  public data: LoadingDialogData;
  constructor(
    public dialogRef: MatDialogRef<LoadingDialog>,
    @Optional() @Inject(MAT_DIALOG_DATA) private customData: LoadingDialogData
  ) {
    this.dialogRef.disableClose = true;
    this.data = customData ? {...defaultLoadingDialogData, ...this.customData } : defaultLoadingDialogData;
   }

  ngOnInit() {
  }

}
